import { http } from 'utils'
import { SET_USER } from 'vx/mutations'

export default {
  namespaced: true,

  state: {
    user: {}
  },

  actions: {
    async authenticate (store, payload) {
      const response = await http.post('/auth', payload)

      return response
    },

    async authorize ({ commit }) {
      const response = await http.get('/user')

      commit(SET_USER, response.data.data)

      return response
    },

    async deauthenticate ({ commit }) {
      await http.delete('/auth')

      commit(SET_USER, {})
    },

    forgotPassword (store, identifier) {
      return http.post('/password/forgot', { identifier })
    },

    resetPassword (store, payload) {
      return http.post('/password/reset', payload)
    },

    async updatePassword ({ commit }, payload) {
      const response = await http.put('/user/password', payload)

      commit(SET_USER, response.data.data)

      return response
    }
  },

  mutations: {
    [SET_USER] (state, user) {
      state.user = user
    }
  }
}
